module.exports = __webpack_public_path__ + "static/media/children2.3afdb0e3.jpg";